<template>
<div class="body1">
 <el-form  :model="form1" :rules="rules" ref="form1" label-width="100px" class="demo-ruleForm">
  <div style="font-size: 35px;font-weight: bold;text-align: center;margin-bottom: 20px">评价申请计划查询</div>
     <el-form-item>
       <label >企业名称：</label>
       <label >{{form1.eName}}</label>
     </el-form-item>
   <el-form-item>
       <label >统一社会信用代码：</label>
       <label >{{form1.eCode}}</label>
     </el-form-item>
   <el-form-item>
       <label >联系人：</label>
       <label >{{form1.contacts}}</label>
     </el-form-item>
   <el-form-item>
       <label >法定代表人：</label>
       <label >{{form1.jperson}}</label>
     </el-form-item>
   <el-form-item>
       <label >联系电话：</label>
       <label >{{form1.tel}}</label>
     </el-form-item>
   <el-form-item>
       <label >地址：</label>
       <label >{{form1.tel}}</label>
     </el-form-item>
   <el-form-item>
       <label >状态：</label>
       <label v-if="form1.state =='1'">完成</label>
        <label v-if="form1.state =='0'">受理中</label>
     </el-form-item>
      </el-form>

   </div>
</template>

<script>
export default {
  name: 'query',
  data () {
    return {
      form1: {
        pid: '',
        eName: '',
        eCode: '',
        jperson: '',
        tel: '',
        createTime: '',
        updateTime: '',
        contacts: '',
        indSubname: '',
        provName: '',
        cityName: '',
        distName: '',
        eAddr: ''
      }
    }
  },
  created () {
    var that = this
    /* 获取父页面参数 */
    /* 后台申请默认值 */
    // eslint-disable-next-line no-undef
    that.$http.get(rootPathssb.rootPath + '/admini/business/find', {params: {id: that.$route.query.pid}}).then(function (response) {
      if (response.data.result === 1) {
        console.log('cg')
        that.form1 = response.data.object
        /* 读取多选默认值，数组化 */
      };

      console.log(response.data)
    }).catch(function (error) {
      console.log(error); console.log('aaa')
    })
  }
}
</script>

<style scoped>
.body1{
  width:600px;
  margin: 0 auto;
}
  label{
    font-size: 22px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/computer/query.vue